export const STATUSES = ['TBD', 'Scheduled', 'In Work', 'Complete']
export const DEPARTMENTS = ['MX', 'AVI', 'INT', 'PA', 'QA']
export const AIRCRAFT_TYPES = ['Jet', 'Piston']

export const STATUS_STYLES = {
  'TBD':       'bg-yellow-100 text-yellow-800',
  'Scheduled': 'bg-gray-100 text-gray-600',
  'In Work':   'bg-blue-100 text-blue-700',
  'Complete':  'bg-green-100 text-green-700',
}

export function sortProjects(projects, sortBy) {
  const today = new Date(); today.setHours(0,0,0,0)

  const tbdOrNoDeparture = projects.filter(p => p.status === 'TBD' || !p.departure_date)
  const rest = projects.filter(p => p.status !== 'TBD' && p.departure_date)

  const sortedTBD = [...tbdOrNoDeparture].sort((a, b) => {
    const aDate = a.arrival_date
    const bDate = b.arrival_date
    if (!aDate && !bDate) return 0
    if (!aDate) return 1
    if (!bDate) return -1
    return new Date(aDate) - new Date(bDate)
  })

  const sortedRest = [...rest].sort((a, b) => {
    const aDate = sortBy === 'departure' ? a.departure_date : a.arrival_date
    const bDate = sortBy === 'departure' ? b.departure_date : b.arrival_date
    if (!aDate && !bDate) return 0
    if (!aDate) return 1
    if (!bDate) return -1
    return new Date(aDate) - new Date(bDate)
  })

  return [...sortedTBD, ...sortedRest]
}

export function lightenColor(hex, amount = 0.4) {
  // Parse hex
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  // Mix with white
  const lr = Math.round(r + (255 - r) * amount)
  const lg = Math.round(g + (255 - g) * amount)
  const lb = Math.round(b + (255 - b) * amount)
  return `rgb(${lr}, ${lg}, ${lb})`
}

export function registrationColor(registration, manualColor= null) {
  if (manualColor) return manualColor
  if (!registration) return '#94a3b8'

  // Use a hash that weights later characters more heavily
  // so N400AX and N400BX get very different colors
  let hash = 0
  for (let i = 0; i < registration.length; i++) {
    const weight = i + 1 // later chars matter more
    hash = (hash + registration.charCodeAt(i) * weight * 2654435761) >>> 0
  }

  // Use golden ratio to spread hues evenly
  const goldenAngle = 137.508
  const rawHue = (hash * goldenAngle) % 360

  // Department color hue ranges to avoid
  const avoidRanges = [
    [0, 15],    // red (overdue)
    [20, 40],   // orange (INT)
    [130, 160], // green (MX)
    [185, 205], // light blue (reserved)
    [210, 240], // blue (AVI)
    [320, 350], // pink (PA)
    [345, 360], // red (overdue)
  ]

  let hue = rawHue
  for (const [start, end] of avoidRanges) {
    if (hue >= start && hue <= end) {
      hue = end + 20
      break
    }
  }

  hue = hue % 360
  return `hsl(${hue}, 60%, 38%)`
}

export function modelColor(model) {
  if (!model) return '#94a3b8'
  let hash = 0
  for (let i = 0; i < model.length; i++) {
    hash = model.charCodeAt(i) + ((hash << 5) - hash)
  }
  const hue = Math.abs(hash) % 360
  return `hsl(${hue}, 60%, 45%)`
}

// Returns true if departure is past today and project is not Complete
export function isDepartureOverdue(project) {
  if (!project.departure_date) return false
  if (project.status === 'Complete') return false
  const today = new Date(); today.setHours(0, 0, 0, 0)
  const departure = new Date(project.departure_date + 'T00:00:00')
  return departure < today
}

// Returns true if arrival is past today and project is not In Work
export function isArrivalOverdue(project) {
  if (!project.arrival_date) return false
  if (project.status === 'In Work' || project.status === 'Complete') return false
  const today = new Date(); today.setHours(0,0,0,0)
  return new Date(project.arrival_date + 'T00:00:00') < today
}